import script from "./ProfileRelationships.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileRelationships.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileRelationships.vue?vue&type=style&index=0&id=511e6b92&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-511e6b92"]])

export default __exports__